'use client'

export default function LoanPdfExtractSkeletons() {
    return (
        <div className="mt-6 flex flex-col gap-4" aria-hidden="true" data-test="pdf-extract-skeletons">
            <div className="h-4 w-40 animate-pulse rounded bg-rm-gray-light" />
            <div className="h-14 w-full animate-pulse rounded-xl bg-rm-gray-light/70" />
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
                <div className="h-14 animate-pulse rounded-xl bg-rm-gray-light/70" />
                <div className="h-14 animate-pulse rounded-xl bg-rm-gray-light/70" />
            </div>
        </div>
    )
}
